<h1 class="email-form-title text-primary-blue-700">Log In</h1>
<div *ngIf="errorMessage">
  <app-message severity="error" [noMargin]="true" data-cy="login-error-message">
    {{ errorMessage }}
  </app-message>
</div>
<div *ngIf="successMessage">
  <app-message severity="success" [noMargin]="true" data-cy="login-success-message">
    {{ successMessage }}
  </app-message>
</div>
<div *ngIf="factor === 'email'" class="message">
  <p>
    Enter the code sent to <strong>{{ email }}</strong
    >.
  </p>
  <p>The code will expire in 30 minutes, so be sure to use it soon.</p>
</div>
<div *ngIf="factor === 'phone'" class="message">
  <p>
    We've sent you a code to <strong>{{ phone }}</strong
    >. This code will expire in 30 minutes, so be sure to use it soon.
  </p>
</div>
<form [formGroup]="verifyCodeForm" (ngSubmit)="onSubmit()" formId="verifyCodeForm" data-cy="login-email-form">
  <div class="grid">
    <div class="col-2 input-container">
      <input
        id="code1"
        [ngClass]="{ error: formError }"
        class="w-full h-full"
        type="text"
        formControlName="code1"
        data-cy="code-input-1"
      />
    </div>
    <div class="col-2 input-container">
      <input
        id="code2"
        [ngClass]="{ error: formError }"
        class="w-full h-full"
        type="text"
        formControlName="code2"
        data-cy="code-input-2"
      />
    </div>
    <div class="col-2 input-container">
      <input
        id="code3"
        [ngClass]="{ error: formError }"
        class="w-full h-full"
        type="text"
        formControlName="code3"
        data-cy="code-input-3"
      />
    </div>
    <div class="col-2 input-container">
      <input
        id="code4"
        [ngClass]="{ error: formError }"
        class="w-full h-full"
        type="text"
        formControlName="code4"
        data-cy="code-input-4"
      />
    </div>
    <div class="col-2 input-container">
      <input
        id="code5"
        [ngClass]="{ error: formError }"
        class="w-full h-full"
        type="text"
        formControlName="code5"
        data-cy="code-input-5"
      />
    </div>
    <div class="col-2 input-container">
      <input
        id="code6"
        [ngClass]="{ error: formError }"
        class="w-full h-full"
        type="text"
        formControlName="code6"
        data-cy="code-input-6"
      />
    </div>
  </div>
  <div *ngIf="formError" class="p-error block ng-star-inserted mt-1">The code must me 6 digits long.</div>
  <p class="inline-link">
    Didn't receive your code? <a (click)="resendCode()" class="inner-link no-underline">Re-send Code</a>
  </p>
  <app-form-footer [disabled]="disableButton" submitLabel="Submit" [noCancel]="true" [fullWidthButtons]="true">
  </app-form-footer>
  <app-separator class="divider" text="OR"></app-separator>
  <button
    pButton
    type="button"
    label="Use Password"
    class="p-button-outlined w-full password-button"
    (click)="onUsePassword()"
    data-cy="use-password-button"
  ></button>
  <p class="inline-link">
    Don't have an account? <a [routerLink]="['/login/new']" class="inner-link no-underline">Sign Up</a>
  </p>
  <app-mobile-footer></app-mobile-footer>
</form>
